import {useEffect} from 'react';
import {useValidateUserToken} from '@aboutyou/user';
import {useLogoutHandler} from '../hooks/useLogoutHandler';
import {Log} from '@aboutyou/mlm';

export const AuthenticationValidator = () => {
  const {data} = useValidateUserToken();
  const {logout} = useLogoutHandler();

  useEffect(() => {
    if (data?.isValid === false) {
      Log.error('@aboutyou/logic-components', 'SessionValidationErrors', {
        error_message:
          'AuthenticationValidator: User is logged in but the Auth Token is not valid',
      });

      logout('sessionValidator');
    }
  }, [data]);

  return null;
};
